import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, msg: error?.message || "Errore imprevisto" };
  }

  componentDidCatch(error, info) {
    console.error("App crash caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#0A0E17] p-6" data-testid="error-boundary">
          <div className="max-w-md text-center space-y-4">
            <h1 className="font-display text-2xl font-extrabold text-slate-100">Qualcosa è andato storto</h1>
            <p className="text-slate-400 text-sm">
              Si è verificato un errore imprevisto. Puoi ricaricare l'app per continuare.
            </p>
            <p className="text-slate-600 text-xs font-mono2 break-words">{this.state.msg}</p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => { this.setState({ hasError: false, msg: "" }); window.location.assign("/"); }}
              className="px-4 py-2 rounded-lg bg-[#10B981] hover:bg-[#059669] text-[#0A0E17] font-semibold"
            >
              Ricarica l'app
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
